// src/components/button/BtnAddDashboard.tsx

import { AddTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

type BtnAddDashboardProps = {
  onClick: () => void
}

export const BtnAddDashboard = ({ onClick }: BtnAddDashboardProps) => (
  <Tooltip title={'Neues Dashboard'}>
    <IconButton onClick={onClick}>
      <AddTwoTone />
    </IconButton>
  </Tooltip>
)
